module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dnHrR"))).then(() => parcelRequire('1iHdE'));